export default __webpack_public_path__ + "static/payroll-for-teams-onboarding-a9140437a1991e5b911e68888f0950f9.png";